import { PlateLetterQueryResponseType } from '@/common/queries/plateLetter/plateLetterQuery.type';
import { fetchApi } from '@/config/axiosSetting';

export const plateLetterFunction = (): Promise<
  PlateLetterQueryResponseType[]
> => {
  return fetchApi.get('selection_item/plate_letter/wop_list/');
};
